import { takeLatest, put, call, all, fork } from 'redux-saga/effects'
import {
    GET_EXPENSE_CONFIG,
    SET_EXPENSE_CONFIG,
    GET_EXPENSE_TYPES,
    SET_EXPENSE_TYPES,
    SAVE_EXPENSE_CONFIG
} from '../actions/action-types';

export function* getExpenseConfigByOperatorCode(action) {
    try {
        const {
            api,
            url,
            apiPayload
        } = { ...action.payload };
        const apiResult = yield call(api, url, apiPayload);
        if (apiResult.status === "SUCCESS") {
            let clientPayload = apiResult.payload;
            if (clientPayload.Status === 'SUCCESS') {
                let serverPayload = clientPayload.Payload;
                yield put({
                    type: SET_EXPENSE_CONFIG,
                    payload: {
                        expenseConfig: serverPayload.expenseConfig,
                        expenseTypes: serverPayload.expenseTypes
                    }
                });
            }
        }
    }
    catch (error) {
        console.error("Error in getting expense config", error);
    }
}

export function* getExpenseTypes(action) {
    try {
        const {
            api,
            url
        } = { ...action.payload };
        const apiResult = yield call(api, url);
        if (apiResult.status === "SUCCESS") {
            let clientPayload = apiResult.payload;
            if (clientPayload.Status === 'SUCCESS') {
                let expenseTypes = clientPayload.Payload;
                // Parse the JSON string if it's a string
                if (typeof expenseTypes === 'string') {
                    expenseTypes = JSON.parse(expenseTypes);
                }
                yield put({
                    type: SET_EXPENSE_TYPES,
                    payload: {
                        expenseTypes: expenseTypes
                    }
                });
            }
        }
    }
    catch (error) {
        console.error("Error in getting expense types", error);
    }
}

export function* saveExpenseConfigSaga(action) {
    try {
        const {
            api,
            url,
            apiPayload
        } = { ...action.payload };
        const apiResult = yield call(api, url, apiPayload);
        if (apiResult.status === "SUCCESS") {
            let clientPayload = apiResult.payload;
            if (clientPayload.Status === 'SUCCESS') {
                // Success - the action creator will handle the response
                return apiResult;
            }
        }
        return apiResult;
    }
    catch (error) {
        console.error("Error in saving expense config", error);
        throw error;
    }
}

function* watchGetExpenseConfigSaga() {
    yield takeLatest(GET_EXPENSE_CONFIG, getExpenseConfigByOperatorCode)
}

function* watchGetExpenseTypesSaga() {
    yield takeLatest(GET_EXPENSE_TYPES, getExpenseTypes)
}

function* watchSaveExpenseConfigSaga() {
    yield takeLatest(SAVE_EXPENSE_CONFIG, saveExpenseConfigSaga)
}

export default function* watchExpenseConfigPageSagas() {
    yield all([
        fork(watchGetExpenseConfigSaga),
        fork(watchGetExpenseTypesSaga),
        fork(watchSaveExpenseConfigSaga)
    ])
}
